<template>
    <div class="page-layout blank contacts-manage mb-10 mt-0">
        <div class="breadcrumbactive">
            <div >
                <span class="pointer" @click="goToTemplateList">Template List</span>
                <div class="text-capitalize" v-if="template_name.length < 15">View {{template_name}}</div>
                <el-tooltip v-else effect= "dark" :content= "template_name" placement= "bottom">
                    <div class="text-capitalize">View {{template_name.slice(0, 15)}}...</div>
                </el-tooltip>
            </div>
        </div>
        <div class="template-list-main-container">
            <div class="template-list-main-container-inner">
                    <div class="template-list-header">
                        <span class="fs-14 text-white text-capitalize">{{template_name}}</span>
                    </div>
                <div v-if="ajax_call_in_progress" class="position-relative">
                    <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center position-relative"/>
                </div>
                <div v-else class="template-list-inner-content">
                    <!-- Multi Part -->
                    <div v-for="(part, part_index) in multi_parts_data" :key="part_index">
                        <div class="infoHeader mt-2">
                            <div class="descriptionheader">
                                <div class="description-text-header-left">
                                    <h5 class="font-weight-bold text-black whiteSpace">{{ part.name.split('').length > 1 ?  part.name[0].toUpperCase() +''+ part.name.slice(1,) : part.name[0].toUpperCase()}}</h5> 
                                </div>
                                <div class="description-text-header-right">
                                    <span class="collapse-addon" v-if="part.show">
                                        <img src="https://cdn.digicollect.com/cdn/scmnew/images/main-collapse.svg" @click="togglePart(false, part_index)" alt="" style="top: 9px !important;transition:0.5s">
                                    </span>
                                    <span class="collapse-addon" v-else>
                                        <img src="https://cdn.digicollect.com/cdn/scmnew/images/main-collapse.svg" alt="" @click="togglePart(true, part_index)" style="top: 9px !important;transform: rotate(180deg);transition:0.5s">
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div v-if="part.show">
                            <div v-for="(que_data, all_questions_index) in part.fields" :key="all_questions_index+'dd'"  class="d-flex mt-3">
                                <div v-if="que_data.type == 'Radio Button'" class="template-list-question-box w-100">
                                    <div class="overflowing-text text-capitalize position-relative" :title="que_data.name">
                                        {{que_data.name}} <sup v-if="que_data.required" class="text-danger asterix-position fs-17">*</sup>
                                    </div>
                                    <el-checkbox class="mt-2" :disabled="true" :value="que_data.add_attachments">Add Attachments</el-checkbox>
                                    <div class="row">
                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                            <div class="d-flex form-check form-check-inline">
                                                <label v-for="(radio_btn, radio_btn_index) in que_data.possible_values" :key="radio_btn_index" class="form-check-label position-relative mt-5 mr-6">
                                                    <input class="form-check-input text-capitalize" :disabled="true" style="top: 5px;left: -5px;width: 20px;height: 20px;" type="radio"
                                                        value="option 1">
                                                    <span class="radio-icon" style="width: 20px;height: 20px;"></span>
                                                    <input type="text" readonly maxlength="50" v-model="que_data.possible_values[radio_btn_index]" :placeholder="'Option '+(radio_btn_index+1)" class="input-border-bottom pb-0" style="width: 200px !important; border-bottom: solid 2px #0d84f2 !important;" />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-reason" v-if="que_data.statement">
                                        Enter a reason
                                    </div>
                                </div>
                                <div v-if="que_data.type == 'Checkbox'" class="template-list-question-box w-100">
                                    <div class="overflowing-text text-capitalize position-relative" :title="que_data.name">
                                        {{que_data.name}} <sup v-if="que_data.required" class="text-danger asterix-position fs-17">*</sup>
                                    </div>
                                    <el-checkbox class="mt-2" :disabled="true" :value="que_data.add_attachments">Add Attachments</el-checkbox>
                                    <div class="row">
                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                            <div class="d-flex align-items-center flex-wrap">
                                                <div v-for="(checkbox, checkbox_index) in que_data.possible_values" :key="checkbox_index" class="d-flex align-items-end mt-5 mr-6">
                                                    <el-checkbox :disabled="true" class="mb-0 mr-2"></el-checkbox>
                                                    <input type="text" readonly maxlength="50" :name="'checkbox_index'+checkbox_index + '' +all_questions_index" :placeholder="'Option '+(checkbox_index+1)" v-model="que_data.possible_values[checkbox_index]" class="input-border-bottom pb-0 text-capitalize" style="width: 200px !important;border-bottom: solid 2px #0d84f2 !important;" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-reason" v-if="que_data.statement">
                                        Enter a reason
                                    </div>
                                </div>
                                <div v-if="que_data.type == 'Drop Down Selection'" class="template-list-question-box w-100">
                                    <div class="overflowing-text text-capitalize position-relative" :title="que_data.name">
                                        {{que_data.name}} <sup v-if="que_data.required" class="text-danger asterix-position fs-17">*</sup>
                                    </div>
                                    <el-checkbox class="mt-2" :disabled="true" :value="que_data.add_attachments">Add Attachments</el-checkbox>
                                    <div class="row">
                                        <div class="col-lg-8 col-md-12 col-sm-12">
                                            <div class="form-group contactGroup mt-5">
                                                <div class="" style="max-width: 300px;">
                                                    <div class="dropdown-list-show">
                                                        <div class="d-flex align-items-center justify-content-between inputFieldNew inputFieldNew-padding" style="border-bottom-left-radius: 0 !important;border-bottom-right-radius: 0 !important;">
                                                            Select an option
                                                            <img style="transform: rotate(180deg);" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/down-arrow-grey.svg" alt="arrow down" width="18" height="18" />
                                                        </div>
                                                        <div class="inputFieldNew inputFieldNew-padding mt-0 text-capitalize" style="overflow: auto; border-top: 0 !important;border-top-left-radius: 0 !important;border-top-right-radius: 0 !important;">
                                                            <div style="height: 120px;">
                                                                <div class="py-1" v-for="(dropdown_data, dropdown_index) in que_data.possible_values" :key="dropdown_index+'dropdown_index'">
                                                                    {{dropdown_data}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-reason" v-if="que_data.statement">
                                        Enter a reason
                                    </div>
                                </div>
                                <div v-if="que_data.type == 'Short Answer Input Field'" class="template-list-question-box w-100">
                                    <div class="overflowing-text text-capitalize position-relative" :title="que_data.name">
                                        {{que_data.name}} <sup v-if="que_data.required" class="text-danger asterix-position fs-17">*</sup>
                                    </div>
                                    <el-checkbox class="mt-2" :disabled="true" :value="que_data.add_attachments">Add Attachments</el-checkbox>
                                    <div class="row">
                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                            <div class="mt-5">
                                                <input type="text" readonly :name="'short_answer'+all_questions_index" placeholder="Short Answer" style="border-bottom: solid 2px #0d84f2 !important;" class="input-border-bottom text-capitalize pb-0" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="que_data.type == 'Long Answer Input Field'" class="template-list-question-box w-100">
                                    <div class="overflowing-text text-capitalize position-relative" :title="que_data.name">
                                        {{que_data.name}} <sup v-if="que_data.required" class="text-danger asterix-position fs-17">*</sup>
                                    </div>
                                    <el-checkbox class="mt-2" :disabled="true" :value="que_data.add_attachments">Add Attachments</el-checkbox>
                                    <div class="row">
                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                            <div class="mt-5">
                                                <input type="text" readonly :name="'long_answer'+all_questions_index" placeholder="Long Answer" style="border-bottom: solid 2px #0d84f2 !important;" class="input-border-bottom text-capitalize pb-0" />
                                                <input type="text" readonly :name="'long_answer'+all_questions_index" placeholder="" style="border-bottom: solid 2px #0d84f2 !important;" class="input-border-bottom pb-0 mt-3" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="que_data.type == 'Date'" class="template-list-question-box w-100">
                                    <div class="overflowing-text text-capitalize position-relative" :title="que_data.name">
                                        {{que_data.name}} <sup v-if="que_data.required" class="text-danger asterix-position fs-17">*</sup>
                                    </div>
                                    <el-checkbox class="mt-2" :disabled="true" :value="que_data.add_attachments">Add Attachments</el-checkbox>
                                    <div class="row">
                                        <div class="col-lg-8 col-md-12 col-sm-12">
                                            <div class="mt-5">
                                                <date-picker name="date"
                                                    class="inputFieldNew-border-bottom date-picker-disabled view-page-cursor text-capitalize" placeholder="MM/DD/YYYY"
                                                    format="MM/DD/YYYY" type="date" lang="en"
                                                    style="border:none !important" :disabled="true">
                                                </date-picker>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="que_data.type == 'Time'" class="template-list-question-box w-100">
                                    <div class="overflowing-text text-capitalize position-relative" :title="que_data.name">
                                        {{que_data.name}} <sup v-if="que_data.required" class="text-danger asterix-position fs-17">*</sup>
                                    </div>
                                    <el-checkbox class="mt-2" :disabled="true" :value="que_data.add_attachments">Add Attachments</el-checkbox>
                                    <div class="row">
                                        <div class="col-lg-8 col-md-12 col-sm-12">
                                            <div class="mt-5">
                                                <date-picker
                                                    class="new-time-picker new-time-picker-icon input-field-underline date-picker-disabled date-picker-clock-icon mt-3 view-page-cursor text-capitalize"
                                                    placeholder="--:--" value-type="format" style="padding-right: 2px !important;" lang="en"
                                                    type="time" format="HH/MM" :disabled="true">
                                                </date-picker>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="que_data.type == 'Tag'" class="template-list-question-box w-100">
                                    <div class="overflowing-text text-capitalize position-relative" :title="que_data.name">
                                        {{que_data.name}} <sup v-if="que_data.required" class="text-danger asterix-position fs-17">*</sup>
                                    </div>
                                    <el-checkbox class="mt-2" :disabled="true" :value="que_data.add_attachments">Add Attachments</el-checkbox>
                                    <div class="row">
                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                            <div class="mt-5">
                                                <input type="text" readonly :name="'short_answer'+all_questions_index" placeholder="Tag Answer" style="border-bottom: solid 2px #0d84f2 !important;" class="input-border-bottom text-capitalize pb-0" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="que_data.type == 'Date & Time'" class="template-list-question-box w-100">
                                    <div class="overflowing-text text-capitalize position-relative" :title="que_data.name">
                                        {{que_data.name}} <sup v-if="que_data.required" class="text-danger asterix-position fs-17">*</sup>
                                    </div>
                                    <el-checkbox class="mt-2" :disabled="true" :value="que_data.add_attachments">Add Attachments</el-checkbox>
                                    <div class="d-flex align-items-center mt-5">
                                        <date-picker name="date"
                                            class="inputFieldNew-border-bottom view-page-cursor date-picker-disabled" placeholder="MM/DD/YYYY"
                                            format="MM/DD/YYYY" type="date" lang="en"
                                            style="border:none !important" :disabled="true">
                                        </date-picker>
                                        <date-picker
                                            class="new-time-picker new-time-picker-icon view-page-cursor input-field-underline date-picker-disabled date-picker-clock-icon"
                                            placeholder="--:--" value-type="format" style="padding-right: 2px !important;" lang="en"
                                            type="time" format="HH/MM" :disabled="true">
                                        </date-picker>
                                    </div>
                                </div>
                                <div v-if="que_data.type == 'Location'" class="template-list-question-box w-100">
                                    <div class="overflowing-text text-capitalize position-relative" :title="que_data.name">
                                        {{que_data.name}} <sup v-if="que_data.required" class="text-danger asterix-position fs-17">*</sup>
                                    </div>
                                    <el-checkbox class="mt-2" :disabled="true" :value="que_data.add_attachments">Add Attachments</el-checkbox>
                                    <div class="row mt-5">
                                        <div class="col-lg-12 col-md-6 col-sm-12">
                                            <input type="text" readonly :name="'Location'+all_questions_index" placeholder="Location" style="border-bottom: solid 2px #0d84f2 !important; cursor: not-allowed" class="input-border-bottom pb-0" />
                                            <div class="d-flex">
                                                <i class="icon icon-map-marker color-blue" style="position: absolute;right: 10px;bottom: 5px;cursor: not-allowed"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Default -->
                    <div>
                        <div v-for="(que_data, all_questions_index) in all_questions" :key="all_questions_index+'dd'" class="d-flex mt-3">
                            <div v-if="que_data.type == 'Radio Button'" class="template-list-question-box w-100">
                                <div class="overflowing-text position-relative text-capitalize" :title="que_data.name">
                                    {{que_data.name}} <sup v-if="que_data.required" class="text-danger asterix-position fs-17">*</sup>
                                </div>
                                <el-checkbox class="mt-2" :disabled="true" :value="que_data.add_attachments">Add Attachments</el-checkbox>
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div class="d-flex form-check form-check-inline">
                                            <label v-for="(radio_btn, radio_btn_index) in que_data.possible_values" :key="radio_btn_index" class="form-check-label position-relative mt-5 mr-6">
                                                <input class="form-check-input text-capitalize" :disabled="true" style="top: 5px;left: -5px;width: 20px;height: 20px;" type="radio"
                                                    value="option 1">
                                                <span class="radio-icon" style="width: 20px;height: 20px;"></span>
                                                <input type="text" readonly maxlength="50" v-model="que_data.possible_values[radio_btn_index]" :placeholder="'Option '+(radio_btn_index+1)" class="input-border-bottom pb-0" style="width: 200px !important; border-bottom: solid 2px #0d84f2 !important;" />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-reason" v-if="que_data.statement">
                                    Enter a reason
                                </div>
                            </div>
                            <div v-if="que_data.type == 'Checkbox'" class="template-list-question-box w-100">
                                <div class="overflowing-text position-relative text-capitalize" :title="que_data.name">
                                    {{que_data.name}} <sup v-if="que_data.required" class="text-danger asterix-position fs-17">*</sup>
                                </div>
                                <el-checkbox class="mt-2" :disabled="true" :value="que_data.add_attachments">Add Attachments</el-checkbox>
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div class="d-flex align-items-center flex-wrap">
                                            <div v-for="(checkbox, checkbox_index) in que_data.possible_values" :key="checkbox_index" class="d-flex align-items-end mt-5 mr-6">
                                                <el-checkbox :disabled="true" class="mb-0 mr-2"></el-checkbox>
                                                <input type="text" readonly maxlength="50" :name="'checkbox_index'+checkbox_index + '' +all_questions_index" :placeholder="'Option '+(checkbox_index+1)" v-model="que_data.possible_values[checkbox_index]" class="input-border-bottom text-capitalize pb-0" style="width: 200px !important;border-bottom: solid 2px #0d84f2 !important;" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-reason" v-if="que_data.statement">
                                    Enter a reason
                                </div>
                            </div>
                            <div v-if="que_data.type == 'Drop Down Selection'" class="template-list-question-box w-100">
                                <div class="overflowing-text position-relative text-capitalize" :title="que_data.name">
                                    {{que_data.name}} <sup v-if="que_data.required" class="text-danger asterix-position fs-17">*</sup>
                                </div>
                                <el-checkbox class="mt-2" :disabled="true" :value="que_data.add_attachments">Add Attachments</el-checkbox>
                                <div class="row">
                                    <div class="col-lg-8 col-md-12 col-sm-12">
                                        <div class="form-group contactGroup mt-5">
                                            <div class="" style="max-width: 300px;">
                                                <div class="dropdown-list-show">
                                                    <div class="d-flex align-items-center justify-content-between inputFieldNew inputFieldNew-padding" style="border-bottom-left-radius: 0 !important;border-bottom-right-radius: 0 !important;">
                                                        Select an option
                                                        <img style="transform: rotate(180deg);" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/down-arrow-grey.svg" alt="arrow down" width="18" height="18" />
                                                    </div>
                                                    <div class="inputFieldNew inputFieldNew-padding mt-0" style="overflow: auto; border-top: 0 !important;border-top-left-radius: 0 !important;border-top-right-radius: 0 !important;">
                                                        <div style="height: 120px;">
                                                            <div class="text-capitalize py-1" v-for="(dropdown_data, dropdown_index) in que_data.possible_values" :key="dropdown_index+'dropdown_index'">
                                                                {{dropdown_data}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-reason" v-if="que_data.statement">
                                    Enter a reason
                                </div>
                            </div>
                            <div v-if="que_data.type == 'Short Answer Input Field'" class="template-list-question-box w-100">
                                <div class="overflowing-text position-relative text-capitalize" :title="que_data.name">
                                    {{que_data.name}} <sup v-if="que_data.required" class="text-danger asterix-position fs-17">*</sup>
                                </div>
                                <el-checkbox class="mt-2" :disabled="true" :value="que_data.add_attachments">Add Attachments</el-checkbox>
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div class="mt-5">
                                            <input type="text" readonly :name="'short_answer'+all_questions_index" placeholder="Short Answer" style="border-bottom: solid 2px #0d84f2 !important;" class="input-border-bottom text-capitalize pb-0" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="que_data.type == 'Long Answer Input Field'" class="template-list-question-box w-100">
                                <div class="overflowing-text position-relative text-capitalize" :title="que_data.name">
                                    {{que_data.name}} <sup v-if="que_data.required" class="text-danger asterix-position fs-17">*</sup>
                                </div>
                                <el-checkbox class="mt-2" :disabled="true" :value="que_data.add_attachments">Add Attachments</el-checkbox>
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div class="mt-5">
                                            <input type="text" readonly :name="'long_answer'+all_questions_index" placeholder="Long Answer" style="border-bottom: solid 2px #0d84f2 !important;" class="input-border-bottom text-capitalize pb-0" />
                                            <input type="text" readonly :name="'long_answer'+all_questions_index" placeholder="" style="border-bottom: solid 2px #0d84f2 !important;" class="input-border-bottom pb-0 mt-3" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="que_data.type == 'Date'" class="template-list-question-box w-100">
                                <div class="overflowing-text position-relative text-capitalize" :title="que_data.name">
                                    {{que_data.name}} <sup v-if="que_data.required" class="text-danger asterix-position fs-17">*</sup>
                                </div>
                                <el-checkbox class="mt-2" :disabled="true" :value="que_data.add_attachments">Add Attachments</el-checkbox>
                                <div class="row">
                                    <div class="col-lg-8 col-md-12 col-sm-12">
                                        <div class="mt-5">
                                            <date-picker name="date"
                                                class="inputFieldNew-border-bottom date-picker-disabled view-page-cursor" placeholder="MM/DD/YYYY"
                                                format="MM/DD/YYYY" type="date" lang="en"
                                                style="border:none !important" :disabled="true">
                                            </date-picker>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="que_data.type == 'Time'" class="template-list-question-box w-100">
                                <div class="overflowing-text position-relative text-capitalize" :title="que_data.name">
                                    {{que_data.name}} <sup v-if="que_data.required" class="text-danger asterix-position fs-17">*</sup>
                                </div>
                                <el-checkbox class="mt-2" :disabled="true" :value="que_data.add_attachments">Add Attachments</el-checkbox>
                                <div class="row">
                                    <div class="col-lg-8 col-md-12 col-sm-12">
                                        <div class="mt-5">
                                            <date-picker
                                                class="new-time-picker new-time-picker-icon input-field-underline date-picker-disabled date-picker-clock-icon mt-3 view-page-cursor"
                                                placeholder="--:--" value-type="format" style="padding-right: 2px !important;" lang="en"
                                                type="time" format="HH/MM" :disabled="true">
                                            </date-picker>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="que_data.type == 'Tag'" class="template-list-question-box w-100">
                                <div class="overflowing-text position-relative text-capitalize" :title="que_data.name">
                                    {{que_data.name}} <sup v-if="que_data.required" class="text-danger asterix-position fs-17">*</sup>
                                </div>
                                <el-checkbox class="mt-2" :disabled="true" :value="que_data.add_attachments">Add Attachments</el-checkbox>
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div class="mt-5">
                                            <input type="text" readonly :name="'short_answer'+all_questions_index" placeholder="Tag Answer" style="border-bottom: solid 2px #0d84f2 !important;" class="input-border-bottom text-capitalize pb-0" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="que_data.type == 'Date & Time'" class="template-list-question-box w-100">
                                <div class="overflowing-text position-relative text-capitalize" :title="que_data.name">
                                    {{que_data.name}} <sup v-if="que_data.required" class="text-danger asterix-position fs-17">*</sup>
                                </div>
                                <el-checkbox class="mt-2" :disabled="true" :value="que_data.add_attachments">Add Attachments</el-checkbox>
                                <div class="d-flex align-items-center mt-5">
                                    <date-picker name="date"
                                        class="inputFieldNew-border-bottom view-page-cursor date-picker-disabled" placeholder="MM/DD/YYYY"
                                        format="MM/DD/YYYY" type="date" lang="en"
                                        style="border:none !important" :disabled="true">
                                    </date-picker>
                                    <date-picker
                                        class="new-time-picker new-time-picker-icon view-page-cursor input-field-underline date-picker-disabled date-picker-clock-icon"
                                        placeholder="--:--" value-type="format" style="padding-right: 2px !important;" lang="en"
                                        type="time" format="HH/MM" :disabled="true">
                                    </date-picker>
                                </div>
                            </div>
                            <div v-if="que_data.type == 'Location'" class="template-list-question-box w-100">
                                <div class="overflowing-text position-relative text-capitalize" :title="que_data.name">
                                    {{que_data.name}} <sup v-if="que_data.required" class="text-danger asterix-position fs-17">*</sup>
                                </div>
                                <el-checkbox class="mt-2 fw-normal" :disabled="true" :value="que_data.add_attachments">Add Attachments</el-checkbox>
                                <div class="row mt-5">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <input type="text" readonly :name="'Location'+all_questions_index" placeholder="Location" style="border-bottom: solid 2px #0d84f2 !important; cursor: not-allowed" class="input-border-bottom pb-0" />
                                        <div class="d-flex">
                                            <i class="icon icon-map-marker color-blue" style="position: absolute;right: 10px;bottom: 5px;cursor: not-allowed"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-center my-4">
                        <button type="button" class="btn btn-new-primary" @click="goToListView" >Close</button>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import { SweetModal } from 'sweet-modal-vue';
import dynamic_template from '../../mixins/dynamic_template';
// import crm from '../../mixins/crm.js';
// import scm from '../../mixins/scm.js';
import ticket from '../../mixins/ticket';
export default {
    mixins: [dynamic_template, ticket],
    components: {
        SweetModal
    },
    data() {
        return {
            template_name: "",
            limit: 10,
            skip: 0,
            isVisible: false,
            search_key: '',
            dropdown_loading: false,
            ajax_call_in_progress: false,
            scrollable: false,
            all_questions: [],
            template_type: '',
            multi_parts_data: [],
            apicall_loading: false,
            scm_products_options: [],
            scm_products_count: 0,
        }
    },
    methods: {
        goToTemplateList() {
            this.$router.push('/settings?type=templatesnew')
        },
        goToListView() {
            this.goToTemplateList();
        },
        async getTemplateDataById(id) {
            this.ajax_call_in_progress = true;
            try {
                let param = {
                    dynamic_template_id: id
                };
                let response = await this.getDynamicTemplate(param);
                if(response.response.template_type == 'multi_part'){
                    this.template_name = response.response.name;
                    this.template_type = response.response.template_type
                    this.multi_parts_data = response.response.multi_parts_data
                    this.multi_parts_data.forEach((data, index) => {
                        data.show = true
                        data.fields.forEach((el, el_index) => {
                            switch (el.type) {
                                case 'radio_button':
                                    el.type = 'Radio Button';
                                    break;
                                case 'check_box':
                                    el.type = 'Checkbox';
                                    break;
                                case 'drop_down':
                                    el.type = 'Drop Down Selection';
                                    break;
                                case 'short_answer':
                                    el.type = 'Short Answer Input Field';
                                    break;
                                case 'long_answer':
                                    el.type = 'Long Answer Input Field';
                                    break;
                                case 'date':
                                    el.type = 'Date';
                                    break;
                                case 'time':
                                    el.type = 'Time';
                                    break;
                                case 'date_time':
                                    el.type = 'Date & Time';
                                    break;
                                case 'tag':
                                    el.type = 'Tag';
                                    break;
                                case 'location':
                                    el.type = 'Location';
                                    break;
                            }
                        })
                    })
                    this.ajax_call_in_progress = false;
                } else {
                    this.all_questions = response.response.fields;
                    this.template_name = response.response.name;
                    this.template_type = response.response.template_type
                    this.all_questions.forEach((data, index) => {
                        switch (data.type) {
                            case 'radio_button':
                                data.type = 'Radio Button';
                                break;
                            case 'check_box':
                                data.type = 'Checkbox';
                                break;
                            case 'drop_down':
                                data.type = 'Drop Down Selection';
                                break;
                            case 'short_answer':
                                data.type = 'Short Answer Input Field';
                                break;
                            case 'long_answer':
                                data.type = 'Long Answer Input Field';
                                break;
                            case 'date':
                                data.type = 'Date';
                                break;
                            case 'time':
                                data.type = 'Time';
                                break;
                            case 'date_time':
                                data.type = 'Date & Time';
                                break;
                            case 'tag':
                                data.type = 'Tag';
                                break;
                            case 'location':
                                data.type = 'Location';
                                break;
                        }
                        this.ajax_call_in_progress = false;
                    })
                    if(this.template_name == 'Digicollect Product Template'){
                        this.getTemplateApiDD()
                    } else if(this.template_name == 'Product Bug Template'){
                        this.getApiDD()
                    }
                }
            }
            catch(err) {
                this.warning_msg = err;
                this.$refs.warning_modal.open();
                this.is_api_calling = false;
            }
        },
        async getApiDD(){
            this.scm_products_options = []
            this.apicall_loading = true
            try{
                let params = {
                    limit: 10,
                    search_key: "",
                    skip: 0
                }
                let response = await this.getScmProductsDD(params)
                this.scm_products_options = response.response.products
                this.all_questions.forEach((el, el_index) => {
                    if(el.is_api_call_required == true && el.name == 'Product'){
                        this.scm_products_options.forEach((e) => {
                            el.possible_values.push(e.name) 
                        })
                    }
                })
                this.scm_products_count = response.response.products.length
                this.apicall_loading = false
            } catch (error) {
                console.log(error)
            }
        },
        async getTemplateApiDD(){
            this.scm_products_options = []
            this.apicall_loading = true
            try{
                let params = {
                    limit: 10,
                    search_key: "",
                    skip: 0
                }
                let response = await this.getProductTemplatesDD(params)
                this.scm_products_options = response.response.products
                this.all_questions.forEach((el, el_index) => {
                    if(el.is_api_call_required == true && el.name == 'Product'){
                        this.scm_products_options.forEach((e) => {
                            el.possible_values.push(e.name) 
                        })
                    }
                })
                this.scm_products_count = response.response.products.length
                this.apicall_loading = false
            } catch (error) {
                console.log(error)
            }
        },
        togglePart(action, index){
            this.multi_parts_data[index].show = action
            this.$forceUpdate();
        }
    },
    mounted() {
        this.getTemplateDataById(this.$route.params.id);
    }
}
</script>
<style scoped>
    .template-list-main-container {
        padding: 13.5px;
        border-radius: 6px;
        background-color: #fff;
    }
    .template-list-main-container-inner {
        padding: 16.5px 0 12.3px;
        border-radius: 6px;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.16);
        background-color: #fff;
    }
    .template-list-header {
        margin: 0 0 14.2px;
        padding: 9.7px 35.5px;
        background-color: #005dae;
    }
    .template-list-inner-content {
        padding: 9.7px 35.5px;
    }
    .template-list-inner-content .row {
        margin-left: -15px !important;
        margin-right: -15px !important;
    }
    .template-list-question-box {
        padding: 12px 18.5px 20px 21.5px;
        box-shadow: 0 0 2px 0 #939393;
        border-radius: 5px;
        /* border: solid 0.3px #6c6d6f; */
        background-color: #fff;
    }
    .input-border-bottom {
        border: 0 !important;
        padding: 5px 8px;
        padding-left: 0;
        width: 100% !important;
        border-bottom: solid 1px #707070 !important;
    }
    .overflowing-text{
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .infoHeader{
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        min-height: 40px;
        position: relative;
        -webkit-box-shadow: none;
        box-shadow: none;
        border-radius: 5px;
        line-height: 40px;
    }
    .infoHeader>.descriptionheader{
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 10px 0px;
        border-bottom: 1px solid transparent;
    }
    .infoHeader>.descriptionheader .description-text-header-right{
        display: block;
        border-bottom: 1px solid #b2b2b3;
        width: 100%;
        margin-left: 10px;
        font-size: 14px;
        /* margin-left: auto; */
        padding-left: 12px;
        color: #00448b;
        font-weight: 500;
    }
    .infoHeader>.descriptionheader .description-text-header-right img{
        float: right;
        color: #00448b;
        width: 23px;
        cursor: pointer;
        position: absolute;
        right: 0px;
        bottom: -15px;
    }
    .text-reason{
        font-size: 14px !important;
		padding: 5px 5px 40px 10px !important;
		display: block;
		width: 100%;
        border-radius: 5px;
		border: solid 1px #3f3f3f!important;
		background: transparent !important;
		color: #8a8a8a;
		font-weight: 500;
		border-radius: 5px !important;
		margin-top: 20px;
        /* margin-left:20px; */
    }
    .position-relative{
        position: relative !important;
    }
    .fs-17{
        font-size: 14px !important;
    }
    .fs-15px{
        font-size: 17px !important;
    }
    .asterix-position{
        position: absolute;
        top: 7px !important;
    }
    .text-grey{
        color: #abaaac;
    }
    .bg-grey-box{
        background: #f1f3f4
    }
    .dotted-grey{
        border: dotted 2px #89898d;
    }
    .no-att-msg{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        color: rgba(59, 77, 92, 0.16);
    }
    .browse-box{
        height: 200px;
    }
    .choose-file{
        border-radius: 5px !important;
    }
    .fs-15px{
        font-size: 15px !important
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        font-weight: 500 !important;
    }
    @media screen and (max-width: 768px) {
        .p-med-12{
            padding-left: 12px !important;
            padding-right: 12px !important;
            padding-top: 12px;
        }
        .pl-med-12{
            padding-left: 12px !important;
        }
        .justify-center-frsm{
            justify-content: center;
        }
    }
</style>